import { LitElement, html, nothing, TemplateResult, PropertyValues } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { getSeverityClass } from '../../../utils/xdr.utils';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { WEB_COMPONENT_GZ_ALERT_GROUP_DETAILS_SIDEPANEL } from '../../../webcomponents.constants';
import { GzSideMenuWebComponent } from '../../../ui/gzSideMenu';
import { translateFn } from '../../../utils/translator.helper';

/**
 * @summary Type here the description of this component
 * @tag gz-alert-group-details-sidepanel
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement(WEB_COMPONENT_GZ_ALERT_GROUP_DETAILS_SIDEPANEL)
export class AlertGroupDetailsSidepanelWebComponent extends LitElement {
  /**
   * See https://lit-element.polymer-project.org/guide/properties
   * Write here the description of this field
   */
  @property({ type: String, attribute: true, reflect: true })
  alertName;

  @property({ type: Object, attribute: true, reflect: true })
  group;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html` ${this.renderSidepanelContent()} `;
  }

  renderSidepanelContent() {
    return html`
      <div class="header mt-6 mb-1">
        <gz-title class="mb-2" fontsize="20" fontweight="400">
          <div class="d-flex mb-4 align-items-center">
            <span
              class="icon icon-sva header-icon"
              style="color:${getSeverityClass(this.group[0].severity)};"
              part="icon"
            ></span>
            <div class="circle has-count">
              <span class="count"> ${this.group.length} </span>
            </div>
            <gz-tooltip tooltipText="${this.alertName}" isEllipsis
              ><gz-text class="d-inline">${this.alertName}</gz-text></gz-tooltip
            >
          </div>
        </gz-title>
      </div>
      <div class="panel-content">${this.renderAlerts()}</div>
    `;
  }

  renderAlerts() {
    if (this.group?.length === 0) {
      return nothing;
    }

    const templateItems: Array<TemplateResult> = [];
    this.group.forEach(alert => {
      templateItems.push(
        html` <div class="d-flex flex-row align-items-center" @click="${() => this.handleAlertClick(alert)}">
          <gz-icon-label icon="icon-sva" iconColor="${getSeverityClass(alert.severity)}" size="20"></gz-icon-label>
          <gz-tooltip class="w-100 label pl-1" toolTipText="${alert.name}" isEllipsis>
            <gz-text class="event-name d-inline" fontSize="${FontSizes.PARAGRAPH_12}" fontWeight="${FontWeights.LIGHT}"
              >${alert.name}</gz-text
            >
          </gz-tooltip>
          <gz-text
            fontSize="${FontSizes.PARAGRAPH_12}"
            fontWeight="${FontWeights.LIGHT}"
            class="resources-count w-70 pl-2"
          >
            ${translateFn('{count} resources', { count: this.computeResources(alert).length })}
          </gz-text>
          <gz-icon name="ds-icon-arrow_right_expand" color="secondary" size="24"></gz-icon>
        </div>`
      );
    });

    return html` <div class="title-container d-flex flex-row mb-2">
        <gz-title
          fontSize="${FontSizes.PARAGRAPH_11}"
          fontWeight="${FontWeights.MEDIUM}"
          class="section-title w-auto text-uppercase"
          >${translateFn('Alerts')}</gz-title
        >
        <gz-title
          fontSize="${FontSizes.PARAGRAPH_11}"
          fontWeight="${FontWeights.LIGHT}"
          class="counter w-auto text-uppercase"
          >(${this.group.length})</gz-title
        >
      </div>
      <show-more-items-in-bulk .items=${templateItems} .showMoreButtonText=${translateFn('Show more')}>
      </show-more-items-in-bulk>`;
  }

  handleAlertClick(alert) {
    Application.modules.xdr.controller.helpers.sidePanelsManager.openAlertDetailsPanel(
      Ext.ComponentQuery.query('[selector=incident-summary-details-panel]')[0],
      alert
    );
  }

  computeResources(alert) {
    const resources = alert.transitions.reduce((acc, item) => {
      if (!item.resources || item.resources.length === 0) {
        return acc;
      }
      acc.push(...item.resources);
      return acc;
    }, []);

    return resources.map(resource => {
      resource.alertId = alert._id;
      resource.companyId = alert.companyId;
      resource.isGzDemo = alert.isGzDemo;
      return resource;
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [WEB_COMPONENT_GZ_ALERT_GROUP_DETAILS_SIDEPANEL]: AlertGroupDetailsSidepanelWebComponent;
  }
}
